import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getApiUrl } from '../util/util';
import { ProductConfigurationResponse } from './ConfigApi';
import { get } from './http';

interface ProductApi {
	getActiveProducts(
		authorizationToken: string,
		tenantId: string,
		config?: AxiosRequestConfig<any>,
	): Promise<AxiosResponse<ProductConfigurationResponse[]>>;
	getProducts(
		authorizationToken: string,
		config?: AxiosRequestConfig<any>,
	): Promise<AxiosResponse<ProductConfigurationResponse[]>>;
	getProductsWithVersion(
		authorizationToken: string,
		version: string,
		config?: AxiosRequestConfig<any>,
	): Promise<AxiosResponse<ProductConfigurationResponse[]>>;
}

export default {
	getActiveProducts(
		authorizationToken: string,
		tenantId: string,
		config?: AxiosRequestConfig<any>,
	) {
		return get(
			`${getApiUrl()}/product/v2/findByTenant/${tenantId}`,
			authorizationToken,
			config,
		);
	},
	getProducts(authorizationToken: string, config?: AxiosRequestConfig<any>) {
		return get(`${getApiUrl()}/products`, authorizationToken, config);
	},
	getProductsWithVersion(
		authorizationToken: string,
		version: string,
		config?: AxiosRequestConfig<any>,
	) {
		return get(
			`${getApiUrl()}/products/${version}`,
			authorizationToken,
			config,
		);
	},
} as ProductApi;
